import React from 'react';
import MobileInput from '../../components/mobileInput';

import TranslationIds from '../../../commons/translationIds';

function renderMobile (p) {
    const {
        fields,
        fieldErrors,
        setSubscribersFields,
        classes,
        translate,
        subscribersFields,
        touched,
    } = p;

    if (!fields || !fields.mobile) {
        return (<React.Fragment></React.Fragment>);
    }
 
    function getLabel () {
        if (fields.mobile === 1) {
            return `${translate(TranslationIds.COMPONENT_PHONE_NUMBER)}*`;
        }
        return translate(TranslationIds.COMPONENT_PHONE_NUMBER);
    }

    function getHelperText () {
        if (touched.mobile && fieldErrors.mobile) {
            if (subscribersFields?.mobile?.length <= 2) {
                return translate(TranslationIds.REGISTRATION_REQUIRED_MOBILE);
            }
            return translate(TranslationIds.REGISTRATION_VALID_MOBILE);
        }
        return '';
    }

    function getValues () {
        const values = {
            countryCode: subscribersFields.countryCode,
            phoneNumber:  subscribersFields.phoneNumber,
            country: subscribersFields.phoneCountry,
            codeIndex: subscribersFields.codeIndex,
        };

        if (!values.countryCode) {
            values.countryCode = '61';
        }

        if (!values.country) {
            values.country = 'au';
        }

        if (!values.codeIndex) {
            values.codeIndex = 2;
        }
        return values;
    }

    return (
        <MobileInput
            error={fieldErrors.mobile}
            label={getLabel()}
            placeHolderText={translate(TranslationIds.COMPONENT_PHONE_NUMBER)}
            helperText={getHelperText()}
            className={classes.mobile}
            value={getValues()}

            onChange={({ value, countryCode, codeIndex, phoneNumber, country }) => {
                if (typeof setSubscribersFields === 'function') {
                    setSubscribersFields({
                        mobile: value,
                        phoneNumber,
                        countryCode,
                        codeIndex,
                        phoneCountry: country,
                    });
                }
            }}
        />
    );
}

export default renderMobile;